import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send.ts';
import { application_registration } from '@axo/shared/data-access/types';

export interface RegistrationResponse {
  Items: application_registration.RegistrationLenderStatus[];
}

export function getStatus({ url: { service: baseURL }, token }: IAPI) {
  return (applicationID: string | undefined): Promise<RegistrationResponse> =>
    send({
      baseURL,
      token,
      path: `/application-registration/application/${applicationID}/status`,
      method: 'GET',
    });
}
